module.exports = __webpack_public_path__ + "img/ie_setting_02_Option.74796904.jpg";